import { useMutation } from '@apollo/client';
import { Browser } from '@capacitor/browser';
import { IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonNote, IonPage, IonRefresher, IonRefresherContent, IonTitle, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import SquareLogo from "assets/icons/Square";
import axios from 'axios';
import { AuthContext } from 'contexts/AuthContext';
import { DELETE_BLOCK_TOKEN } from 'graphql/mutations';
import useMerchantProfile from 'hooks/useMerchantProfile';
import { checkmarkOutline, chevronBackOutline, trash } from 'ionicons/icons';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import './Square.css';

const Square = () => {
  const { authState } = useContext(AuthContext)
  const history = useHistory();
  const { data, refetch } = useMerchantProfile(authState.user.uid, true);
  const [sending, setSending] = useState(false);
  const [btnText, setBtnText] = useState('Send Email');
  const square_app_id = 'sq0idp-Z-w2c_bNMSPlB0n5bvXHgw';
  const scopes = [
    'ITEMS_READ',
    'MERCHANT_PROFILE_READ',
    'GIFTCARDS_READ',
    'GIFTCARDS_WRITE'
  ];

  const [deleteToken] = useMutation(DELETE_BLOCK_TOKEN);

  const authorizeBlock = async () => {
    Browser.addListener('browserFinished', async () => {
      refetch();
    });
    await Browser.open({ url: `https://connect.squareup.com/oauth2/authorize?client_id=${square_app_id}&response_type=code&scope=${scopes.join('+')}&state=${authState.token}` });
  }

  useIonViewWillEnter(() => {
    refetch()
  });

  const doRefresh = (event) => {
    refetch();
    event.detail.complete();
  };

  const deleteBlockToken = async (tokenId) => {
    const payload = {
      variables: {
        userId: authState.user.uid,
        id: tokenId
      }
    }
    await deleteToken(payload);
    refetch();
  }

  const sendBlockEmail = async () => {
    const axiosClient = await axios.create({
      baseURL: 'https://checkout.oshiapp.com/api/square',
      timeout: 30000,
      headers: {
        Authorization: `Bearer ${authState.token}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });
    setSending(true);
    const res = await axiosClient.post(authState.user.uid, {});
    setSending(false);

    if (res.data?.success)
      setBtnText('Successfully sent!');
    else
      setBtnText('Send Email');
  }


  return (
    <IonPage className={'square-page-root'}>
      <IonHeader className={'ion-no-border'}>
        <IonToolbar className={"background-color"}>
          <IonButtons slot="start">
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}><IonIcon icon={chevronBackOutline} /></IonButton>
          </IonButtons>
          <IonTitle>Connect to Square</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <IonCard>
          <IonCardContent>
            <div slot="start" className={"inverted"}>
              <SquareLogo height={42} />
            </div>
            <IonLabel>Connect your Square point of sale to the Oshi app to improve the experience for customers and staff.</IonLabel>
            <br />
            <hr />
            <IonList lines="none">
              <IonItem><IonIcon
                icon={checkmarkOutline}
                size="small" /><p>Redeem Oshi vouchers using Square</p></IonItem>
              <IonItem><IonIcon
                icon={checkmarkOutline}
                size="small" /><p>Seamless promotion creation</p></IonItem>
              <IonItem><IonIcon
                icon={checkmarkOutline}
                size="small" /><p>Track your Oshi sales</p></IonItem>
            </IonList>
            <br />
            <hr />
            <IonList lines="none">
              {data?.merchants[0]?.block_tokens.length > 0 ?
                data?.merchants[0]?.block_tokens.map((block) => {
                  return <IonItem key={block.id}><IonLabel className="ion-text-wrap"><h2>{block.id}</h2><p>Expires: {block.expires_at}</p></IonLabel><IonNote><IonButton color="danger" onClick={() => deleteBlockToken(block.id)}><IonIcon icon={trash} /></IonButton></IonNote></IonItem>
                }) : data ? (
                  <>
                    <IonButton
                      expand="block"
                      onClick={() => authorizeBlock()}>Authorize</IonButton>
                    <hr />
                    <IonButton
                      expand="block"
                      onClick={() => !sending ? sendBlockEmail() : null} disabled={sending || btnText === 'Successfully sent!'}>{sending ? 'Sending' : btnText}</IonButton>
                  </>
                ) : <IonItem><IonLabel>Loading...</IonLabel></IonItem>}
            </IonList>
          </IonCardContent>
        </IonCard>

      </IonContent>
    </IonPage>
  )
}

export default Square
